import * as Types from './types';

export const setOpen = (open: boolean, newStudentId?: string) => ({
  type: Types.SWITCH_STUDENT_CART_MODAL_OPEN,
  payload: {
    open,
    newStudentId,
  },
});
